import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgTrigger = (props) => /* @__PURE__ */ _jsx("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 32 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M8 23.5H7C7 24.0523 7.44772 24.5 8 24.5V23.5ZM24.5 23.5V24.5C25.0523 24.5 25.5 24.0523 25.5 23.5H24.5ZM24.5 17.5H25.5C25.5 16.9477 25.0523 16.5 24.5 16.5V17.5ZM8 17.5V16.5C7.44772 16.5 7 16.9477 7 17.5H8ZM8 24.5H24.5V22.5H8V24.5ZM25.5 23.5V17.5H23.5V23.5H25.5ZM7 17.5V23.5H9V17.5H7ZM24.5 16.5H16.25V18.5H24.5V16.5ZM16.25 16.5H8V18.5H16.25V16.5ZM16.975 16.8113L12.225 11.8113L10.775 13.1887L15.525 18.1887L16.975 16.8113ZM12 10.5C12 11.3284 11.3284 12 10.5 12V14C12.433 14 14 12.433 14 10.5H12ZM10.5 12C9.67157 12 9 11.3284 9 10.5H7C7 12.433 8.567 14 10.5 14V12ZM9 10.5C9 9.67157 9.67157 9 10.5 9V7C8.567 7 7 8.567 7 10.5H9ZM10.5 9C11.3284 9 12 9.67157 12 10.5H14C14 8.567 12.433 7 10.5 7V9Z",
		fill: "currentColor"
	})
});
export default SvgTrigger;
